/* DSL Bandwidth video — hide auto-playing videos on slow connections */
(function(){
  var c = navigator.connection;
  if (!c) return;
  if (c.saveData || /^(slow-2g|2g|3g)$/.test(c.effectiveType || "")) {
    document.querySelectorAll("video[autoplay]").forEach(function(v){
      v.removeAttribute("autoplay");
      v.preload = "none";
      var poster = v.poster;
      if (poster) {
        var fallback = document.createElement("img");
        fallback.src = poster; fallback.alt = ""; fallback.loading = "lazy";
        v.replaceWith(fallback);
      }
    });
  }
})();